import React from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { COMBINATIONS_PAYOUTS } from '../../enums/cardTypes';
import { winningStore } from '../../store/winningStore';

export const Combinations = observer(() => {
  const { winCombination } = winningStore;
  const t = useTranslation();
  return (
    <div className='tb-left-combinations-top'>
      <div className='tb-com-top-wrp'>
        <div className='tb-com-top-title-block'>
          <p className='combination-title'>{t('COMBINATIONS')}</p>
        </div>
        <div className='tb-com-top-cont-block'>
          <div className='combinations-row-wrapper'>
            <div className='comb-row-inside'>
              {COMBINATIONS_PAYOUTS.map(({ winType, img, type, odd }) => (
                <div
                  key={winType}
                  className={`comb-row-block ${winType === winCombination ? 'active' : ''}`}
                >
                  <div className='comb-row-block-inner'>
                    <div className='comb-row-block-col-img'>
                      <img src={img} alt='' />
                    </div>
                    <div className='comb-row-block-col-name'>
                      <p className='comb-row-block-name'>{t(type)}</p>
                    </div>
                    <div className='comb-row-block-col-coef'>
                      <p className='comb-row-block-coef'>x{odd}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
